import { mix, clamp, mixColor, createPathMorph, createSvg, createMotionSvg, createMotionLine, createMotionPath, createMotionEllipse, createStrokePath, createStrokeRect, pointsPath, mixPoints, NS, INK, PINK, easeMotion, setMotionPaint, setDashedStroke } from './helpers.js';


function renderNps() {
    const svg = createMotionSvg();
    const group = document.createElementNS(NS, "g");
    group.setAttribute("transform", "translate(38 38)");
    svg.appendChild(group);

    const staticCorners = [
        [[2, 122], [2, 238], [6, 242], [122, 242]],
        [[122, 2], [238, 2], [242, 6], [242, 122]],
    ];
    const movingCorners = [
        {
            node: createStrokePath(group),
            start: [[36.2856, 122], [36.2856, 40.2858], [40.2856, 36.2858], [122, 36.2858]],
            end: [[122, 36.2856], [203.714, 36.2856], [207.714, 40.2856], [207.714, 122]],
        },
        {
            node: createStrokePath(group),
            start: [[122, 207.714], [203.714, 207.714], [207.714, 203.714], [207.714, 122]],
            end: [[36.2856, 122], [36.2856, 203.714], [40.2856, 207.714], [122, 207.714]],
        },
    ];
    const staticNodes = staticCorners.map((points) => {
        const node = createStrokePath(group);
        node.setAttribute("d", pointsPath(points));
        return node;
    });
    const rects = [
        { node: createStrokeRect(group), start: { x: 53.4287, y: 190.571, r: -90, cx: 53.4287, cy: 190.571 }, end: { x: 53.4292, y: 53.4287, r: 0, cx: 87.7149, cy: 87.7144 } },
        { node: createStrokeRect(group), start: { x: 122, y: 122, r: -90, cx: 122, cy: 122 }, end: { x: 122, y: 122, r: 0, cx: 156.2857, cy: 156.2857 } },
    ];
    const allNodes = [...staticNodes, ...movingCorners.map((item) => item.node), ...rects.map((item) => item.node)];

    return {
        node: svg,
        speed: 0.08,
        leaveSpeed: 0.08,
        touchSpeed: 0.06,
        touchLeaveSpeed: 0.06,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t * t * (3 - 2 * t);
            const stroke = mixColor(INK, PINK, smooth);
            const opacity = mix(0.2, 1, smooth);

            allNodes.forEach((node) => {
                node.setAttribute("stroke", stroke);
                node.setAttribute("stroke-opacity", String(opacity));
            });

            movingCorners.forEach((item) => {
                item.node.setAttribute("d", pointsPath(mixPoints(item.start, item.end, smooth)));
            });

            rects.forEach((item) => {
                const x = mix(item.start.x, item.end.x, smooth);
                const y = mix(item.start.y, item.end.y, smooth);
                const r = mix(item.start.r, item.end.r, smooth);
                const cx = mix(item.start.cx, item.end.cx, smooth);
                const cy = mix(item.start.cy, item.end.cy, smooth);
                item.node.setAttribute("x", String(x));
                item.node.setAttribute("y", String(y));
                item.node.setAttribute("transform", `rotate(${r} ${cx} ${cy})`);
            });
        },
    };
}

function renderNotority() {
    const svg = createMotionSvg();
    const group = document.createElementNS(NS, "g");
    group.setAttribute("transform", "translate(38 38)");
    svg.appendChild(group);

    const outer = document.createElementNS(NS, "circle");
    outer.setAttribute("cx", "122");
    outer.setAttribute("cy", "122");
    outer.setAttribute("r", "120");

    const inner = document.createElementNS(NS, "circle");
    inner.setAttribute("cx", "122");
    inner.setAttribute("cy", "122");
    inner.setAttribute("r", "102.857");

    const diamond = createMotionPath(
        group,
        "M122 193.637C113.567 160.406 90.5412 127.01 62 120.318C90.5412 113.627 113.567 80.2313 122 47C130.433 80.2313 153.459 113.627 182 120.318C153.459 127.01 130.433 160.406 122 193.637Z",
    );

    [outer, inner].forEach((circle) => {
        circle.setAttribute("fill", "none");
        circle.setAttribute("stroke-width", "4");
        circle.setAttribute("stroke-linecap", "round");
        circle.setAttribute("stroke-linejoin", "round");
        circle.setAttribute("stroke-dasharray", "1 12");
        group.insertBefore(circle, diamond);
    });

    const nodes = [outer, inner, diamond];

    return {
        node: svg,
        speed: 0.07,
        leaveSpeed: 0.07,
        touchSpeed: 0.05,
        touchLeaveSpeed: 0.05,
        apply(progress) {
            const eased = easeMotion(progress);
            const stroke = mixColor(INK, PINK, eased);
            const opacity = mix(0.25, 1, eased);

            nodes.forEach((node) => {
                node.setAttribute("stroke", stroke);
                node.setAttribute("stroke-opacity", String(opacity));
            });

            diamond.setAttribute("transform", `rotate(${mix(0, -90, eased)} 122 122)`);
        },
    };
}

function renderPyramid() {
    const svg = createMotionSvg();
    const group = document.createElementNS(NS, "g");
    group.setAttribute("transform", "translate(38 38)");
    svg.appendChild(group);

    const triangles = [
        { startY: 222, endY: 202 },
        { startY: 202, endY: 162 },
        { startY: 182, endY: 122 },
        { startY: 162, endY: 82 },
        { startY: 142, endY: 42 },
        { startY: 2, endY: 2 },
    ];
    const nodes = triangles.map(() => createStrokePath(group));

    return {
        node: svg,
        speed: 0.07,
        leaveSpeed: 0.07,
        touchSpeed: 0.06,
        touchLeaveSpeed: 0.06,
        apply(progress) {
            const eased = easeMotion(progress);
            const stroke = mixColor(INK, PINK, eased);
            const opacity = mix(0.25, 1, eased);

            nodes.forEach((node, index) => {
                const y = mix(triangles[index].startY, triangles[index].endY, eased);
                node.setAttribute("d", `M122 ${y}L2.0002 242H242L122 ${y}Z`);
                node.setAttribute("stroke", stroke);
                node.setAttribute("stroke-opacity", String(opacity));
            });
        },
    };
}

function renderAtitude() {
    const svg = createMotionSvg();
    const group = document.createElementNS(NS, "g");
    svg.appendChild(group);

    const leftCircle = document.createElementNS(NS, "circle");
    leftCircle.setAttribute("cx", "86");
    leftCircle.setAttribute("cy", "86");
    leftCircle.setAttribute("r", "84");

    const rightCircle = document.createElementNS(NS, "circle");
    rightCircle.setAttribute("cy", "86");
    rightCircle.setAttribute("r", "84");

    const lineSpecs = [
        { y: 37, start: [137, 147], end: [122, 142] },
        { y: 48, start: [129, 155], end: [114, 150] },
        { y: 60, start: [126, 158], end: [106, 158] },
        { y: 73, start: [122, 162], end: [102, 162] },
        { y: 86, start: [122, 162], end: [102, 162] },
        { y: 99, start: [122, 162], end: [102, 162] },
        { y: 112, start: [126, 158], end: [106, 158] },
        { y: 124, start: [129, 155], end: [114, 150] },
        { y: 136, start: [137, 147], end: [122, 142] },
    ];
    const lines = lineSpecs.map(() => document.createElementNS(NS, "line"));

    [leftCircle, rightCircle, ...lines].forEach((node) => {
        node.setAttribute("fill", "none");
        node.setAttribute("stroke-width", "4");
        node.setAttribute("stroke-linecap", "round");
        node.setAttribute("stroke-linejoin", "round");
        node.setAttribute("stroke-dasharray", "1 12");
    });
    lines.forEach((line) => group.appendChild(line));
    group.insertBefore(rightCircle, lines[0]);
    group.insertBefore(leftCircle, rightCircle);

    return {
        node: svg,
        apply(progress) {
            const eased = easeMotion(progress);
            const stroke = mixColor(INK, PINK, eased);
            const opacity = mix(0.25, 1, eased);
            group.setAttribute("transform", `translate(${mix(18, 28, eased)} 74)`);

            leftCircle.setAttribute("stroke", stroke);
            leftCircle.setAttribute("stroke-opacity", String(opacity));
            rightCircle.setAttribute("cx", String(mix(198, 178, eased)));
            rightCircle.setAttribute("stroke", stroke);
            rightCircle.setAttribute("stroke-opacity", String(opacity));

            lines.forEach((line, index) => {
                const spec = lineSpecs[index];
                line.setAttribute("x1", String(mix(spec.start[0], spec.end[0], eased)));
                line.setAttribute("x2", String(mix(spec.start[1], spec.end[1], eased)));
                line.setAttribute("y1", String(spec.y));
                line.setAttribute("y2", String(spec.y));
                line.setAttribute("stroke", stroke);
                line.setAttribute("stroke-opacity", String(opacity));
            });
        },
    };
}

function renderConsumerProfile() {
    const svg = createMotionSvg();
    const group = document.createElementNS(NS, "g");
    group.setAttribute("transform", "translate(38 38)");
    svg.appendChild(group);

    const squares = [
        { x: 2, y: 2, w: 239.203, h: 239.394, startRot: 0 },
        { x: 25.722, y: 26.22, w: 190.112, h: 189.773, startRot: 18 },
        { x: 46.128, y: 46.308, w: 150.884, h: 150.738, startRot: 36 },
        { x: 61.816, y: 61.716, w: 119.719, h: 119.663, startRot: 54 },
        { x: 74.315, y: 73.693, w: 94.929, h: 94.949, startRot: 72 },
        { x: 83.994, y: 83.926, w: 75.349, h: 75.41, startRot: 0 },
    ];
    const nodes = squares.map((square) => {
        const rect = document.createElementNS(NS, "rect");
        rect.setAttribute("x", String(square.x));
        rect.setAttribute("y", String(square.y));
        rect.setAttribute("width", String(square.w));
        rect.setAttribute("height", String(square.h));
        rect.setAttribute("rx", "4");
        rect.setAttribute("fill", "none");
        rect.setAttribute("stroke-width", "4");
        rect.setAttribute("stroke-linecap", "round");
        rect.setAttribute("stroke-linejoin", "round");
        rect.setAttribute("stroke-dasharray", "1 12");
        group.appendChild(rect);
        return rect;
    });

    return {
        node: svg,
        apply(progress) {
            const eased = easeMotion(progress);
            const stroke = mixColor(INK, PINK, eased);
            const opacity = mix(0.25, 1, eased);

            nodes.forEach((node, index) => {
                const square = squares[index];
                const rotation = mix(square.startRot, 0, eased);
                const centerX = square.x + square.w / 2;
                const centerY = square.y + square.h / 2;
                node.setAttribute("stroke", stroke);
                node.setAttribute("stroke-opacity", String(opacity));
                node.setAttribute("transform", `rotate(${rotation} ${centerX} ${centerY})`);
            });
        },
    };
}

function renderPriceTesting() {
    const svg = createMotionSvg();
    const ovalsGroup = document.createElementNS(NS, "g");
    const dotsGroup = document.createElementNS(NS, "g");
    svg.append(ovalsGroup, dotsGroup);

    const ovalSpecs = [
        { startRx: 120, endRx: 105 },
        { startRx: 93, endRx: 81.375 },
        { startRx: 67, endRx: 58.625 },
        { startRx: 40, endRx: 35 },
    ];
    const ovals = ovalSpecs.map(() => {
        const ellipse = document.createElementNS(NS, "ellipse");
        ellipse.setAttribute("cx", "122");
        ellipse.setAttribute("cy", "102");
        ellipse.setAttribute("ry", "100");
        setDashedStroke(ellipse);
        ovalsGroup.appendChild(ellipse);
        return ellipse;
    });

    const starSpecs = [
        {
            centerY: 20,
            d: "M17.7851 9.80564C18.3183 7.44507 21.6817 7.44507 22.2149 9.80564V9.80564C22.5605 11.3355 24.3162 12.0627 25.6423 11.2253V11.2253C27.6885 9.93316 30.0668 12.3115 28.7747 14.3577V14.3577C27.9373 15.6839 28.6645 17.4395 30.1944 17.7851V17.7851C32.5549 18.3183 32.5549 21.6817 30.1944 22.2149V22.2149C28.6645 22.5605 27.9373 24.3162 28.7747 25.6423V25.6423C30.0668 27.6885 27.6885 30.0668 25.6423 28.7747V28.7747C24.3161 27.9373 22.5605 28.6645 22.2149 30.1944V30.1944C21.6817 32.5549 18.3183 32.5549 17.7851 30.1944V30.1944C17.4395 28.6645 15.6838 27.9373 14.3577 28.7747V28.7747C12.3115 30.0668 9.93316 27.6885 11.2253 25.6423V25.6423C12.0627 24.3161 11.3355 22.5605 9.80564 22.2149V22.2149C7.44507 21.6817 7.44507 18.3183 9.80564 17.7851V17.7851C11.3355 17.4395 12.0627 15.6838 11.2253 14.3577V14.3577C9.93316 12.3115 12.3115 9.93316 14.3577 11.2253V11.2253C15.6839 12.0627 17.4395 11.3355 17.7851 9.80564V9.80564Z",
        },
        {
            centerY: 73.333,
            d: "M17.7851 63.139C18.3183 60.7784 21.6817 60.7784 22.2149 63.139V63.139C22.5605 64.6689 24.3162 65.3961 25.6423 64.5586V64.5586C27.6885 63.2665 30.0668 65.6448 28.7747 67.691V67.691C27.9373 69.0172 28.6645 70.7728 30.1944 71.1184V71.1184C32.5549 71.6516 32.5549 75.0151 30.1944 75.5483V75.5483C28.6645 75.8939 27.9373 77.6495 28.7747 78.9756V78.9756C30.0668 81.0218 27.6885 83.4002 25.6423 82.108V82.108C24.3161 81.2706 22.5605 81.9978 22.2149 83.5277V83.5277C21.6817 85.8883 18.3183 85.8883 17.7851 83.5277V83.5277C17.4395 81.9978 15.6838 81.2706 14.3577 82.108V82.108C12.3115 83.4002 9.93316 81.0218 11.2253 78.9756V78.9756C12.0627 77.6495 11.3355 75.8939 9.80564 75.5483V75.5483C7.44507 75.0151 7.44507 71.6516 9.80564 71.1184V71.1184C11.3355 70.7728 12.0627 69.0172 11.2253 67.691V67.691C9.93316 65.6448 12.3115 63.2665 14.3577 64.5586V64.5586C15.6839 65.3961 17.4395 64.6689 17.7851 63.139V63.139Z",
        },
        {
            centerY: 126.667,
            d: "M17.7851 116.472C18.3183 114.112 21.6817 114.112 22.2149 116.472V116.472C22.5605 118.002 24.3162 118.729 25.6423 117.892V117.892C27.6885 116.6 30.0668 118.978 28.7747 121.024V121.024C27.9373 122.351 28.6645 124.106 30.1944 124.452V124.452C32.5549 124.985 32.5549 128.348 30.1944 128.882V128.882C28.6645 129.227 27.9373 130.983 28.7747 132.309V132.309C30.0668 134.355 27.6885 136.734 25.6423 135.441V135.441C24.3161 134.604 22.5605 135.331 22.2149 136.861V136.861C21.6817 139.222 18.3183 139.222 17.7851 136.861V136.861C17.4395 135.331 15.6838 134.604 14.3577 135.441V135.441C12.3115 136.734 9.93316 134.355 11.2253 132.309V132.309C12.0627 130.983 11.3355 129.227 9.80564 128.882V128.882C7.44507 128.348 7.44507 124.985 9.80564 124.452V124.452C11.3355 124.106 12.0627 122.351 11.2253 121.024V121.024C9.93316 118.978 12.3115 116.6 14.3577 117.892V117.892C15.6839 118.729 17.4395 118.002 17.7851 116.472V116.472Z",
        },
    ];
    const stars = starSpecs.map((spec) => {
        const path = document.createElementNS(NS, "path");
        path.setAttribute("d", spec.d);
        path.setAttribute("fill", "none");
        path.setAttribute("stroke-width", "4");
        path.setAttribute("stroke-linecap", "round");
        path.setAttribute("stroke-linejoin", "round");
        path.setAttribute("stroke-dasharray", "1 8.5");
        dotsGroup.appendChild(path);
        return { path, centerY: spec.centerY };
    });

    return {
        node: svg,
        apply(progress) {
            const eased = easeMotion(progress);
            const stroke = mixColor(INK, PINK, eased);
            const opacity = mix(0.25, 1, eased);
            const ovalX = mix(38, 53, eased);
            const ovalY = mix(58, 38, eased);
            const ovalScaleX = mix(1, 214 / 244, eased);
            const ovalScaleY = mix(1, 244 / 204, eased);

            ovalsGroup.setAttribute("transform", `translate(${ovalX} ${ovalY}) scale(${ovalScaleX} ${ovalScaleY})`);
            ovals.forEach((ellipse, index) => {
                ellipse.setAttribute("rx", String(mix(ovalSpecs[index].startRx, ovalSpecs[index].endRx, eased)));
                ellipse.setAttribute("stroke", stroke);
                ellipse.setAttribute("stroke-opacity", String(opacity));
            });

            dotsGroup.setAttribute("transform", "translate(140 86)");
            stars.forEach(({ path, centerY }) => {
                path.setAttribute("stroke", stroke);
                path.setAttribute("stroke-opacity", String(opacity));
                path.setAttribute("transform", `rotate(${mix(0, 90, eased)} 20 ${centerY})`);
            });
        },
    };
}

function renderPackageTesting() {
    const svg = createMotionSvg();
    const artGroup = document.createElementNS(NS, "g");
    svg.appendChild(artGroup);

    const layers = [
        {
            box: [38.8, 38.6, 243.2, 243.4],
            viewBox: [243.203, 243.394],
            rotate: false,
            d: "M237.203 2H6C3.79086 2 2 3.79086 2 6V237.394C2 239.603 3.79087 241.394 6.00001 241.394H237.203C239.412 241.394 241.203 239.603 241.203 237.394V6C241.203 3.79086 239.412 2 237.203 2Z",
        },
        {
            box: [55, 55, 210, 210],
            viewBox: [214, 214],
            rotate: false,
            d: "M208 2H6C3.79086 2 2 3.79086 2 6V208C2 210.209 3.79086 212 6 212H208C210.209 212 212 210.209 212 208V6C212 3.79086 210.209 2 208 2Z",
        },
        {
            box: [92, 82, 135, 156],
            viewBox: [139, 157.844],
            rotate: true,
            d: "M67.4989 2.07825C68.7371 1.36287 70.2629 1.36287 71.5011 2.07825L135.001 38.7671C136.238 39.4818 137 40.802 137 42.2306V115.614C137 117.042 136.238 118.362 135.001 119.077L71.5011 155.766C70.2629 156.481 68.7371 156.481 67.4989 155.766L3.99889 119.077C2.76191 118.362 2 117.042 2 115.614V42.2306C2 40.802 2.76191 39.4818 3.99889 38.7671L67.4989 2.07825Z",
        },
        {
            box: [103, 95, 113, 130],
            viewBox: [117, 131.861],
            rotate: true,
            d: "M56.5055 2.07771C57.7403 1.36743 59.2597 1.36743 60.4945 2.07771L112.994 32.2768C114.235 32.9905 115 34.3128 115 35.7441V96.1168C115 97.5481 114.235 98.8704 112.994 99.5841L60.4945 129.783C59.2597 130.493 57.7403 130.493 56.5055 129.783L4.00554 99.5841C2.76481 98.8704 2 97.5481 2 96.1168V35.7441C2 34.3128 2.76481 32.9905 4.00554 32.2768L56.5055 2.07771Z",
        },
        {
            box: [115, 108, 90, 104],
            viewBox: [94, 105.844],
            rotate: true,
            d: "M44.9989 2.07825C46.2371 1.36287 47.7629 1.36287 49.0011 2.07825L90.0011 25.7671C91.2381 26.4818 92 27.802 92 29.2306V76.6135C92 78.0421 91.2381 79.3623 90.0011 80.077L49.0011 103.766C47.7629 104.481 46.2371 104.481 44.9989 103.766L3.99889 80.077C2.76191 79.3623 2 78.0421 2 76.6135V29.2306C2 27.802 2.76191 26.4818 3.99889 25.7671L44.9989 2.07825Z",
        },
    ];
    const nodes = layers.map((layer) => {
        const [x, y, width, height] = layer.box;
        const [viewWidth, viewHeight] = layer.viewBox;
        const group = document.createElementNS(NS, "g");
        group.setAttribute("transform", `translate(${x} ${y}) scale(${width / viewWidth} ${height / viewHeight})`);

        const path = document.createElementNS(NS, "path");
        path.setAttribute("d", layer.d);
        path.setAttribute("fill", "none");
        path.setAttribute("stroke-width", "4");
        path.setAttribute("stroke-linecap", "round");
        path.setAttribute("stroke-linejoin", "round");
        path.setAttribute("stroke-dasharray", "1 12");
        group.appendChild(path);
        artGroup.appendChild(group);

        return { path, layer, centerX: viewWidth / 2, centerY: viewHeight / 2 };
    });

    return {
        node: svg,
        apply(progress) {
            const eased = easeMotion(progress);
            const stroke = mixColor(INK, PINK, eased);
            artGroup.setAttribute("opacity", String(mix(0.5, 1, eased)));

            nodes.forEach(({ path, layer, centerX, centerY }) => {
                path.setAttribute("stroke", stroke);
                path.setAttribute("stroke-opacity", String(mix(0.5, 1, eased)));
                path.setAttribute("transform", layer.rotate ? `rotate(${mix(0, -30, eased)} ${centerX} ${centerY})` : "");
            });
        },
    };
}

function renderProductTest() {
    const svg = createMotionSvg();
    const artGroup = document.createElementNS(NS, "g");
    artGroup.setAttribute("transform", "translate(18 73)");
    svg.appendChild(artGroup);

    const rectSpecs = [
        {
            start: { x: 2, y: 2, w: 169.627, h: 169.627 },
            end: { x: 2, y: 2, w: 180.833, h: 169.167 },
        },
        {
            start: { x: 112.373, y: 2, w: 169.627, h: 169.627 },
            end: { x: 101.167, y: 2, w: 180.833, h: 169.167 },
        },
    ];
    const lineYs = [15.1668, 26.8336, 38.5, 50.1664, 61.8337, 73.5001, 85.1665, 96.8334, 108.5, 120.167, 131.833, 143.5, 155.167];
    const lineEndYs = [15.1667, 26.8333, 38.5, 50.1667, 61.8333, 73.5, 85.1667, 96.8333, 108.5, 120.167, 131.833, 143.5, 155.167];

    const setStrokeBase = (node) => {
        node.setAttribute("fill", "none");
        node.setAttribute("stroke-width", "4");
        node.setAttribute("stroke-linecap", "round");
        node.setAttribute("stroke-linejoin", "round");
        node.setAttribute("stroke-dasharray", "1 12");
    };

    const rects = rectSpecs.map(() => {
        const rect = document.createElementNS(NS, "rect");
        rect.setAttribute("rx", "4");
        setStrokeBase(rect);
        artGroup.appendChild(rect);
        return rect;
    });
    const lines = lineYs.map(() => {
        const line = document.createElementNS(NS, "line");
        setStrokeBase(line);
        artGroup.appendChild(line);
        return line;
    });

    return {
        node: svg,
        apply(progress) {
            const eased = easeMotion(progress);
            const stroke = mixColor(INK, PINK, eased);
            const strokeOpacity = mix(0.5, 1, eased);
            artGroup.setAttribute("opacity", String(mix(0.5, 1, eased)));

            rects.forEach((rect, index) => {
                const spec = rectSpecs[index];
                rect.setAttribute("x", String(mix(spec.start.x, spec.end.x, eased)));
                rect.setAttribute("y", String(mix(spec.start.y, spec.end.y, eased)));
                rect.setAttribute("width", String(mix(spec.start.w, spec.end.w, eased)));
                rect.setAttribute("height", String(mix(spec.start.h, spec.end.h, eased)));
                rect.setAttribute("stroke", stroke);
                rect.setAttribute("stroke-opacity", String(strokeOpacity));
            });

            lines.forEach((line, index) => {
                const y = mix(lineYs[index], lineEndYs[index], eased);
                line.setAttribute("x1", String(mix(125.333, 112.5, eased)));
                line.setAttribute("x2", String(mix(159.833, 171.5, eased)));
                line.setAttribute("y1", String(y));
                line.setAttribute("y2", String(y));
                line.setAttribute("stroke", stroke);
                line.setAttribute("stroke-opacity", String(strokeOpacity));
            });
        },
    };
}

function renderSegmentation() {
    const svg = createMotionSvg();
    const items = [
        { start: { x: 44, y: 40, w: 185.806, h: 185.806 }, end: { x: 20, y: 20, w: 120, h: 120 } },
        { start: { x: 67.226, y: 67.0967, w: 185.806, h: 185.806 }, end: { x: 100, y: 100, w: 120, h: 120 } },
        { start: { x: 90.4517, y: 94.1934, w: 185.806, h: 185.806 }, end: { x: 180, y: 180, w: 120, h: 120 } },
    ];
    const nodes = items.map(() => {
        const rect = document.createElementNS(NS, "rect");
        rect.setAttribute("rx", "4");
        rect.setAttribute("fill", "none");
        rect.setAttribute("stroke-width", "4");
        rect.setAttribute("stroke-linecap", "round");
        rect.setAttribute("stroke-linejoin", "round");
        rect.setAttribute("stroke-dasharray", "1 12");
        svg.appendChild(rect);
        return rect;
    });

    return {
        node: svg,
        apply(progress) {
            const eased = easeMotion(progress);
            const stroke = mixColor(INK, PINK, eased);
            const opacity = mix(0.25, 1, eased);

            nodes.forEach((node, index) => {
                const from = items[index].start;
                const to = items[index].end;
                node.setAttribute("x", String(mix(from.x, to.x, eased)));
                node.setAttribute("y", String(mix(from.y, to.y, eased)));
                node.setAttribute("width", String(mix(from.w, to.w, eased)));
                node.setAttribute("height", String(mix(from.h, to.h, eased)));
                node.setAttribute("stroke", stroke);
                node.setAttribute("stroke-opacity", String(opacity));
            });
        },
    };
}

export { renderNps, renderNotority, renderPyramid, renderAtitude, renderConsumerProfile, renderPriceTesting, renderPackageTesting, renderProductTest, renderSegmentation };
